module.exports = __webpack_public_path__ + "img/Snelling-t-26677-015.1428fe57.jpg";